import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRightUpCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowRightUpCircle"><Path d="M12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 14.5V8.5H9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 15.5L15 9" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowRightUpCircle;
